import {z as zod} from "zod";
import {DEFAULT_QUOTATION_EXPIRING_SOON_BEFORE_DAYS} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/b2bQuotationEngineWorkspaceCapability/domain/B2bQuotationWorkflowConstants";

export type B2bQuotationEngineWorkspaceCapabilityConfiguration = {
    minRfqOrderValue: number;
    quotationExpiringSoonBeforeDays: number;
    quoteExpiryWindowDays: number;
    requireCompanyNameForRfq: boolean;
};

export const b2bQuotationEngineWorkspaceCapabilityConfigurationValidator: zod.ZodType<B2bQuotationEngineWorkspaceCapabilityConfiguration> = zod.strictObject({
    minRfqOrderValue: zod.number().nonnegative(),
    quotationExpiringSoonBeforeDays: zod.number().int().positive().default(DEFAULT_QUOTATION_EXPIRING_SOON_BEFORE_DAYS),
    quoteExpiryWindowDays: zod.number().int().positive(),
    requireCompanyNameForRfq: zod.boolean(),
});
